// Mounts the workflow engine app (smart_workflow_builder) under /workflows/*:
// the approvals inbox, the workflow and part pipeline designer, and runs.
import React, { lazy, Suspense } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

const WorkflowApplication = lazy(() => import('smart_workflow_builder/WorkflowApplication'));

// AppLayout's <main> has pt 10 (80px) and pb 3 (24px) around the outlet.
const CATALOG_CHROME_PX = 104;

class WorkflowsErrorBoundary extends React.Component<{ children: React.ReactNode }, { error?: Error }> {
  state: { error?: Error } = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Box sx={{ p: 6, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Workflows could not load
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {this.state.error.message}
        </Typography>
        <Button variant="contained" onClick={() => this.setState({ error: undefined })}>
          Retry
        </Button>
      </Box>
    );
  }
}

const WorkflowsRouteWrapper: React.FC = () => (
  <WorkflowsErrorBoundary>
    <Suspense
      fallback={
        <Box sx={{ display: 'grid', placeItems: 'center', minHeight: 320 }}>
          <CircularProgress size={28} />
        </Box>
      }
    >
      <WorkflowApplication embedded chromeOffset={CATALOG_CHROME_PX} />
    </Suspense>
  </WorkflowsErrorBoundary>
);

export default WorkflowsRouteWrapper;
